import axios from "axios";
import { dispatchItemToRedux } from "./CommonActions";
import ReducerTypes from "../Types/ReducerTypes";

export function getHeaderAnnouncement() {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      axios({
        method: "GET",
        baseURL: "http://localhost:4000/",
        url: "announces",
      })
        .then((res) => {
          dispatch(
            dispatchItemToRedux({
              type: ReducerTypes.HEADER_MESSAGE,
              payload: res.data.message,
            })
          );
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
}
